@if (currentAiDocument(); as document) {
  <div class="flex h-full min-w-[400px] flex-col overflow-y-auto rounded-3xl bg-white p-4 shadow-md">
    <div class="mb-8 flex items-center justify-between">
      <div class="flex items-center gap-3">
        <button
          class="flex items-center justify-center rounded-full bg-transparent p-2 hover:bg-gray-4"
          (click)="hideDetails()"
        >
          <mat-icon [fontIcon]="'keyboard_backspace'"></mat-icon>
        </button>
        <h4 class="text-gray-900 text-xl font-semibold">{{ "medicalDocuments.label.details" | translate }}</h4>
      </div>
      @if (canEdit()) {
        <button
          class="flex items-center justify-center rounded-full border-2 border-primary-500 bg-transparent p-1.5 text-primary-500 hover:bg-gray-4"
          (click)="openEditMode()"
        >
          <mat-icon [fontIcon]="'edit'"></mat-icon>
        </button>
      }
    </div>

    <div class="flex flex-col gap-4">
      @if (!isDocumentBoundToUser) {
        <div class="flex w-full items-center gap-4 rounded-lg bg-warning-100 p-4 text-sm text-black">
          <mat-icon
            class="text-orange-warning"
            [fontIcon]="'warning_amber'"
          ></mat-icon>
          <div class="flex flex-col items-start gap-1">
            <span class="font-bold">{{ "medicalDocuments.errors.analyzingErrorTitle" | translate }}</span>
            <span>{{ "medicalDocuments.errors.userIdMismatch" | translate }}</span>
          </div>
        </div>
      }

      <div class="flex w-full flex-col items-start justify-center gap-2">
        <span class="text-gray-2">{{ "medicalDocuments.details.label.title" | translate }}</span>
        <span class="font-bold">{{ document.documentTitle }}</span>
      </div>
      <shared-info-badge
        class="-mt-3"
        [withIcon]="true"
        [iconType]="'mat-icon'"
        [icon]="'attach_file'"
        [text]="formattedFileName()"
      ></shared-info-badge>

      <div class="flex w-full flex-col items-start justify-center gap-2">
        <span class="text-gray-2">{{ "medicalDocuments.details.label.type" | translate }}</span>
        <span class="font-bold">{{ "medicalDocuments.types." + getDocumentType(document.type) | translate }}</span>
      </div>

      @if (linkedAppointment()) {
        <div class="flex w-full flex-col items-start justify-center gap-2">
          <span class="text-gray-2">{{ "medicalDocuments.details.label.appointment" | translate }}</span>
          <div class="flex w-full flex-col gap-2 rounded-xl bg-gray-4 p-4">
            <div class="flex items-center justify-between">
              <span class="text-sm text-gray-2">{{ formatDate(linkedAppointment().metadata?.appointment_full_date) }}</span>
              <shared-status
                [statusValue]="linkedAppointment().status"
                [statusMessage]="'statuses.appointments.' + linkedAppointment().status | translate"
              ></shared-status>
            </div>
            <span class="font-semibold">{{ linkedAppointment().metadata?.name }}</span>
          </div>
        </div>
      }

      <div class="flex w-full flex-col items-start justify-center">
        <span class="text-gray-2">{{ "medicalDocuments.details.label.date" | translate }}</span>
        <span class="font-bold">{{ formatDate(document.documentDate) }}</span>
      </div>

      <div class="flex w-full flex-col items-start justify-center">
        <span class="mb-2 text-gray-2">{{ "medicalDocuments.details.label.tags" | translate }}</span>
        <div class="flex flex-wrap gap-2">
          @for (tag of document.healthManagerTags; track tag) {
            <span class="inline-flex items-center rounded-full bg-purple-100 px-2 py-1 text-sm font-medium text-purple-600">
              {{ tag }}
            </span>
          }
        </div>
      </div>

      <div class="flex w-full flex-col items-start justify-center">
        <span class="mb-2 text-gray-2">{{ "medicalDocuments.details.label.memberTags" | translate }}</span>
        <div class="flex flex-wrap gap-2">
          @for (tag of document.memberTags; track tag) {
            <span class="inline-flex items-center rounded-full bg-purple-100 px-2 py-1 text-sm font-medium text-purple-600">
              {{ tag }}
            </span>
          }
        </div>
      </div>
    </div>
  </div>
}
